module.exports = __webpack_public_path__ + "static/media/18ECA38.d45bf103.jpg";